import { useState } from "react";
import { Button } from "@/components/ui/button";
import { UserPlus, UserX } from "lucide-react";
import { AppointmentJoin } from "@/repositories/appointments.repository";
import { AssignmentModal } from "@/components/shared/assignment-modal";
import { ConfirmUnassignDialog } from "@/components/shared/ConfirmUnassignDialog";
import { useAppointmentActions } from "@/app/vendors/appointments/hooks/useAppointmentActions";
import { AssigneeSummary } from "@/components/shared/AssigneeSummary";

interface VendorAppointmentAssignmentProps {
  appointment: AppointmentJoin;
  onAppointmentUpdate?: (updatedAppointment: AppointmentJoin) => void;
}

export default function VendorAppointmentAssignment({ appointment, onAppointmentUpdate }: VendorAppointmentAssignmentProps) {
  const [assignmentModalOpen, setAssignmentModalOpen] = useState(false);
  const [confirmUnassignOpen, setConfirmUnassignOpen] = useState(false);

  const { assigningResource, handleAssignResource, handleUnassignResource, canAssignResources, canUnassignResource, hasAssignment } =
    useAppointmentActions({ appointment, onAppointmentUpdate });

  if (!canAssignResources && !canUnassignResource) {
    return (
      <div className="flex items-center gap-2">
        {hasAssignment ? (
          <div className="flex items-center gap-2">
            <AssigneeSummary appointment={appointment} />
          </div>
        ) : (
          <span className="text-sm text-muted-foreground">—</span>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center gap-2">
        {hasAssignment ? (
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2">
              <AssigneeSummary appointment={appointment} />
            </div>
            {canUnassignResource && (
              <Button variant="outline" size="sm" onClick={() => setConfirmUnassignOpen(true)} disabled={assigningResource} aria-label="Unassign resource">
                <UserX className="w-3 h-3" />
              </Button>
            )}
          </div>
        ) : (
          <Button variant="outline" onClick={() => setAssignmentModalOpen(true)} disabled={assigningResource}>
            <UserPlus className="w-3 h-3 mr-1" />
            Assign
          </Button>
        )}
      </div>

      <AssignmentModal
        isOpen={assignmentModalOpen}
        onClose={() => setAssignmentModalOpen(false)}
        appointment={appointment}
        onAssign={handleAssignResource}
        isLoading={assigningResource}
      />
      <ConfirmUnassignDialog open={confirmUnassignOpen} onOpenChange={setConfirmUnassignOpen} onConfirm={() => void handleUnassignResource()} busy={assigningResource} />
    </>
  );
}
